// Configurações da API Externa
export const API_CONFIG = {
  BASE_URL: 'http://srv-mupa.ddns.net:5678',
  API_PREFIX: '/api',
  STATIC_DATA: {
    ORDERS: '/data/ordens_zaffari.json'
  },
  LOCAL_DB: {
    BASE_URL: 'http://localhost:5680',
    ENDPOINTS: {
      ORDERS: '/orders',
      ORDER_DETAILS: '/orders/details',
      IMPORT_ORDERS: '/orders/import',
      HEALTH: '/health'
    }
  },
  ENDPOINTS: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/me',
    CHANGE_PASSWORD: '/auth/change-password',
    HEALTH: '/health',
    STATS: '/stats',
    USERS: '/users',
    CUSTOMERS: '/customers',
    CUSTOMER_ORDERS: '/customers/{code}/orders',
    CUSTOMER_ORDERS_COMPLETE: '/customers/{code}/orders/complete',
    ORDERS: '/orders',
    ORDER_BY_ID: '/orders/{id}',
    ORDER_ITEMS: '/orders/{id}/items',
    ORDER_MATERIALS: '/orders/{id}/materials',
    ORDER_SERVICES: '/orders/{id}/services',
    ORDER_TIMES: '/orders/{id}/times',
    ORDER_COMPLETE: '/orders/{id}/complete',
    INTEGRATOR_STATUS: '/integrator/status',
    INTEGRATOR_START: '/integrator/start',
    INTEGRATOR_STOP: '/integrator/stop',
    INTEGRATOR_RESTART: '/integrator/restart',
    INTEGRATOR_CHECK_PRIVILEGES: '/integrator/check-privileges'
  },
  TIMEOUT: {
    DEFAULT: 10000,
    HEALTH_CHECK: 5000,
    LONG_REQUEST: 30000
  },
  SYNC: {
    INTERVAL_MS: 300000,
    CUSTOMER_CODES: [
      '430', '1612', '1966', '2217', '2218', '2219', '2316', '2317', '2318', '2320', 
      '2322', '2720', '2890', '3204', '3320', '3431', '3510', '3662', '4005', '4056', 
      '4107', '4109', '4141', '4176', '4229', '4267', '4307', '5488', '6093', '6155', 
      '7284', '7404', '7405', '7406', '7664', // Comercial Zaffari
      '2319', '2321', '4598', '4763', '5096', '5360', '5375', '5707', '6092', '6503', 
      '6854', '7128', '7286', // Stok Center
      '2824', '2826', '3839', '3889', '3903', '4018', '4023', '4249', '4700', '4913', 
      '4924', '5144', '6173'  // Cia. Zaffari
    ],
    DATE_RANGE_DAYS: 365
  },
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000
  },
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

// Função para construir URLs completas
export const buildApiUrl = (endpoint) => {
  const rawBase = (API_CONFIG.BASE_URL || process.env.REACT_APP_API_BASE_URL || '').trim();
  const base = rawBase.replace(/\s+/g, '');
  const baseNoSlash = base.replace(/\/+$/,'');
  const prefixRaw = (API_CONFIG.API_PREFIX || process.env.REACT_APP_API_PREFIX || '').trim();
  const prefixNoSpaces = prefixRaw.replace(/\s+/g, '');
  const prefixNormalized = ('/' + prefixNoSpaces.replace(/^\/+/, '')).replace(/\/+$/,'');
  const ep = String(endpoint || '');
  const epWithSlash = ep.startsWith('/') ? ep : `/${ep}`;
  
  // Se BASE_URL for o origin atual (modo proxy HTTPS), não adicionamos o prefixo /api 
  // se o endpoint já for um caminho de API completo ou se quisermos que o Cloudflare 
  // intercepte a rota raiz /api/
  const isProxyMode = typeof window !== 'undefined' && baseNoSlash === window.location.origin;
  
  let full;
  if (isProxyMode) {
    // No Cloudflare, chamamos /api/auth/login diretamente no domínio atual
    full = `${baseNoSlash}${prefixNormalized}${epWithSlash}`;
  } else {
    full = `${baseNoSlash}${prefixNormalized}${epWithSlash}`;
  }

  if (!/^https?:\/\//.test(full)) {
    const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
    if (origin && prefixNormalized) {
      full = `${origin}${prefixNormalized}${epWithSlash}`;
    }
  }
  console.log(`🔧 URL construída: ${full}`);
  return full;
};

// Função para obter configuração de timeout baseada no tipo de requisição
export const getTimeout = (type = 'default') => {
  return API_CONFIG.TIMEOUT[type.toUpperCase()] || API_CONFIG.TIMEOUT.DEFAULT;
};

export default API_CONFIG;
